module.exports = __webpack_public_path__ + "img/1579239711.dc5042bb.jpg";